import { CloseOutlined, EditOutlined, KeyOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Col, Form, Image, Input, message, Row, Space, Spin, Typography } from 'antd';
import {useState, useEffect} from 'react';
import userImg from '../../assets/images/userInfor.png'
import api from '../../API';

function Profile() {
    const [form] = Form.useForm();
    const user = JSON.parse(localStorage.getItem('user'));
    const [loading, setLoading] = useState({spin: false, btnUserProfile: false, btnUserPassword: false});
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        setLoading({...loading, spin: true});
        const {username, phone, email, TaxCode} = user;
        form.setFieldsValue({username, phone: phone.length === 10? phone: '0'+ phone, email, TaxCode});
        setLoading({...loading, spin: false});
    }, [])

    async function handleSubmitProfile(values) {
        try {
            setLoading({...loading, btnUserProfile: true});
            const response = await api.update_user_ById(user?.userId, values);
            message.success(response.message);
            localStorage.setItem('user', JSON.stringify({...values, userId: user?.userId}));
        } catch (error) {
            message.error(error.message);
        }
        finally { setLoading({...loading, btnUserProfile: false}); }
    }

    async function handleSubmitPassword(values) {
        try {
            setLoading({...loading, btnUserPassword: true});
            const response = await api.update_userPassword_ById(JSON.parse(localStorage.user).userId,values)
            if(response) message.success('Password changed successfully');
            else message.error('The current password is incorrect')
        } catch (error) {
            message.error(error.message);
        }
        finally { setLoading({...loading, btnUserPassword: false}); }
    }
    return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
        <Space>
            <Avatar size="small" icon={<UserOutlined />} />
            <Typography.Title level={5} style={{margin: 0}}>Profile Details</Typography.Title>
        </Space>
        }
        loading={loading.spin}
    >
        <Row>
            <Col span={24}>
                <Space direction="vertical" align='center' style={{width: '100%'}} styles={{item: {width: '100%', textAlign: 'center', marginBottom: 16}}}>
                    <Image width={100} src={userImg} preview={false}/>
                </Space>
            </Col>
        </Row>
        <Row gutter={[20,16]}>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} >
                <Card
                    style={{width:'100%', height: '100%', boxSizing:'border-box', border: '1px solid #ccc'}}
                    title={<Typography.Title level={5} style={{margin:0}}>Your Profile</Typography.Title>} 
                    extra={
                    <Button type='link' onClick={e => setIsEdit(true)}>
                        Edit profile
                    </Button>
                    }
                >
                    <Form name='formUserInfor' form={form} onFinish={handleSubmitProfile} variant={isEdit? 'outlined':"borderless"} labelAlign='left' labelCol={{xxl:{span: 4}, xl:{span: 4}, lg:{span: 24}, md:{span: 24}, sm:{span: 24}, xs:{span: 24}}}>
                        <Form.Item label='User name'  name='username' rules={[{required: true, message: 'The user name cannot be empty'}]}>
                            <Input disabled variant='borderless'/>
                        </Form.Item>
                        <Form.Item label='Phone' name='phone' rules={[{required: true, message: 'The phone cannot be empty'}, {pattern: /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/, message: 'Phone number is incorrect'}]}>
                            <Input maxLength={10} disabled={!isEdit} allowClear/>
                        </Form.Item>
                        <Form.Item label='Email'  name='email' rules={[{required: true, message: 'The email cannot be empty'}, {type: 'email', message:'email is incorrect'}]}>
                            <Input disabled={!isEdit} allowClear/>
                        </Form.Item>
                        <Form.Item label='Tax Code'  name='TaxCode' rules={[{required: true, message: 'The tax code cannot be empty'}]}>
                            <Input disabled={!isEdit} allowClear/>
                        </Form.Item>
                        <Form.Item>
                            <Space >
                                <Button 
                                    onClick={e => {
                                        const {username, phone, email, TaxCode} = user;
                                        form.setFieldsValue({username, phone: phone.length === 10? phone: '0'+ phone, email, TaxCode});
                                        setIsEdit(false);
                                    }} 
                                    disabled={!isEdit} icon={<CloseOutlined/>}>Cancel</Button>
                                <Button type='primary' htmlType='submit' loading={loading.btnUserProfile} disabled={!isEdit} icon={<EditOutlined/>}>Update</Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                <Card 
                    style={{width:'100%', height:'100%', boxSizing:'border-box', border: '1px solid #ccc'}}
                    title={<Typography.Title level={5} style={{margin:0}}>Change password</Typography.Title>}
                >  
                    <Form name='formUserPassword' onFinish={handleSubmitPassword} layout='vertical'>
                        <Form.Item label='Current Password' name='curpassword' rules={[{required: true, message: 'The current password cannot be empty'}, {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/, message:'Minimum 8 characters (A->Z, a->z, 0->9, !@#...)'}]}>
                            <Input.Password allowClear/>
                        </Form.Item>
                        <Form.Item label='New Password' name='password' rules={[{required: true, message: 'The new password cannot be empty'}, {pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/, message:'Minimum 8 characters (A->Z, a->z, 0->9, !@#...)'}]}>
                            <Input.Password allowClear/>
                        </Form.Item>
                        <Form.Item>
                            <Button type='primary' htmlType='submit' loading={loading.btnUserPassword} icon={<KeyOutlined/>}>Change Password</Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
        </Row>
    </Card>
    )
}

export default Profile;